import { ShoppingBag, DollarSign, Package, Users } from 'lucide-react'
import { formatVND, formatNumber } from '@/lib/formatters'
import { StatCard } from '../components/StatCard'
import { OrdersChart } from '../components/OrdersChart'
import { RecentOrdersTable } from '../components/RecentOrdersTable'
import { TopProductsList } from '../components/TopProductsList'
import {
  getStats, getLast7DaysOrders, getRecentOrders, getTopProducts,
} from '../../services/dashboardService'

export function DashboardPage() {
  const stats = getStats()
  const chartData = getLast7DaysOrders()
  const recentOrders = getRecentOrders()
  const topProducts = getTopProducts()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-text">Dashboard</h1>
        <p className="text-sm text-muted mt-1">Tổng quan hoạt động cửa hàng — cập nhật realtime</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        <StatCard
          label="Tổng đơn hàng"
          value={formatNumber(stats.orders.value)}
          delta={stats.orders.delta}
          icon={<ShoppingBag className="w-6 h-6" />}
          tone="brand"
        />
        <StatCard
          label="Doanh thu"
          value={formatVND(stats.revenue.value)}
          delta={stats.revenue.delta}
          icon={<DollarSign className="w-6 h-6" />}
          tone="green"
        />
        <StatCard
          label="Sản phẩm"
          value={formatNumber(stats.products.value)}
          delta={stats.products.delta}
          icon={<Package className="w-6 h-6" />}
          tone="orange"
        />
        <StatCard
          label="Khách hàng"
          value={formatNumber(stats.customers.value)}
          delta={stats.customers.delta}
          icon={<Users className="w-6 h-6" />}
          tone="purple"
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[1fr_380px] gap-6">
        <OrdersChart data={chartData} />
        <TopProductsList products={topProducts} />
      </div>

      <RecentOrdersTable orders={recentOrders} />
    </div>
  )
}
